import React from 'react';

function IcFilter() {
  return (
    <svg
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.49967 9.66658V5.49992H0.333008V4.49992H4.49967V0.333252H5.49967V4.49992H9.66634V5.49992H5.49967V9.66658H4.49967Z'
        fill='white'
      />
    </svg>
  );
}

export default IcFilter;
